export default {
  name: 'ngx-ui-scroll',
  version: '4.2.0'
};
